<template>
  <Grid gtr="auto 1fr 80px" class="sidebar text-white bg-dark-gradient">
    <div class="text-center border-bottom-sm q-py-md">
      <Logo />
    </div>

    <Grid align-content="start" class="routes relative-position">
      <SidebarItem
        v-for="(route, index) of sidebarRoutes"
        :key="route.label"
        v-bind="route"
        :class="{ 'border-bottom-sm': index !== sidebarRoutes.length - 1, active: activeIndex === index }"
      />
      <div v-if="activeIndex >= 0" class="active-el bg-green-gradient" :style="{ top: activeIndex * 54 + 'px' }"></div>
    </Grid>

    <Grid
      v-ripple
      justify-items="center"
      align-content="center"
      class="cursor-pointer logout relative-position non-selectable"
      @click.native="logout"
    >
      <q-icon name="power_settings_new" size="18px"></q-icon>
      <div class="text-caption-1">Logout</div>
      <span class="text-caption q-mt-sm">v{{ appVersion }}</span>
    </Grid>
  </Grid>
</template>

<script>
import Grid from '@/ui/Grid'
import Logo from '@/reusable/svg-icons/Logo'
import SidebarItem from './SidebarItem'

export default {
  components: {
    Grid,
    Logo,
    SidebarItem
  },

  computed: {
    appVersion() {
      return process.env.VUE_APP_VERSION
    },

    activeIndex() {
      const routePath = this.$route.path
      return this.sidebarRoutes.findIndex(({ route }) => {
        if (typeof route === 'string') return routePath.startsWith(route)
        return routePath.startsWith(route.path)
      })
    }
  },

  created() {
    this.sidebarRoutes = [
      { label: 'Dashboard', route: '/dashboard' },
      {
        label: 'Subscriptions',
        route: { path: '/subscriptions' }
      },
      { label: 'Products', route: '/products' },
      { label: 'Vendors', route: '/vendors' },
      { label: 'Publishers', route: '/publishers' },
      { label: 'Licenses', route: '/licenses' },
      { label: 'Email', route: '/email-outbox' },
      { label: 'Financials', route: '/financial' },
      { label: 'Reports', route: '/reports' },
      { label: 'Kanban', route: '/kanban-boards' }
    ]
  },

  methods: {
    logout() {
      this.$store.dispatch('logout')
    }
  }
}
</script>

<style lang="scss" scoped>
@supports not (scrollbar-width: none) {
  .sidebar::-webkit-scrollbar {
    width: 0;
  }
}

.border-bottom-sm {
  border-bottom: 1px solid var(--r-secondary-2);
}

.sidebar {
  width: 135px;
  overflow-y: auto;
  scrollbar-width: none;

  $sidebar-route-height: 54px;
  $transition-delay-timing: 400ms cubic-bezier(0.23, 1, 0.32, 1);

  .route {
    position: relative;
    text-decoration: none;
    height: $sidebar-route-height;
    transition: font-size $transition-delay-timing, font-weight $transition-delay-timing;
  }

  .active-el {
    position: absolute;
    height: $sidebar-route-height;
    width: 100%;
    transition: top $transition-delay-timing;
  }

  .logout {
    height: 100%;
    align-self: center;
  }
}
</style>
